<template>
    <section class="content">
        <loading :active.sync="isLoading" :color="'#39a2db'" :loader="'dots'" :is-full-page="true"></loading>
        <div class="container-fluid">
            <div class="row mb-3">
                <div class="col-12">
                    <router-link to="/rapor/type" class="btn btn-outline-secondary btn-sm">
                        <i class="fas fa-arrow-left"></i> Kembali
                    </router-link>
                </div>
            </div>
        </div>
        <table class="table table-hover table-striped table-no-border" ref="tablesuswa" id="tb_psikotes">
            <thead>
                <tr>
                    <th>Jenis Psikotes</th>
                    <th>Nama Ujian</th>
                    <th>Tanggal</th>
                    <th>Detail</th>
                </tr>
            </thead>
            <tbody @click="handleClick">
            </tbody>
        </table>
    </section>
    <!-- /.content -->
</template>
<script>
import { createTable, authFetch, auth } from '@/libs/hxcore';
import pageLoading from '@/mixins/pageLoading';
import $ from 'jquery';
import Swal from "sweetalert2";
import moment from "moment";

export default {
    mixins: [pageLoading],
    name: 'DetailHasilUjianPSIKOTES',
    data() {
        return {
            errors: [],
            filter: {},
            siswa: {},
            method: '',
            roles: '',
            id: '',
            branch: '',
            userid: '',
        }
    },
    created: function() {
        this.roles = this.$route.meta.roles;
    },
    methods: {
        handleClick(e) {
            if (e.target.matches('.link-role')) {
                this.$router.push({ path: '/permit/' + e.target.dataset.id })
                return false;
            }
            if (e.target.matches(".btn-detail")) {
                var mapel_id = e.target.dataset.mapel;
                var hasil_id = e.target.dataset.hasil;
                var ujian_code = e.target.dataset.ujian;
                
                if (mapel_id == 34) {
                    // Tes Kecermatan — menggunakan ujian_code karena RekapHasilKecermatan memakai endpoint /hasil_kecermatan/{ujian_code}
                    this.$router.push({ path: '/rekap-hasil-kecermatan', query: { ujian_code: hasil_id } });
                } else if (mapel_id == 40) {
                    // Simbol Aritmatika — menggunakan hasil_id
                    this.$router.push({ path: '/rekap-hasil-simbol-aritmatika', query: { hasil_id: hasil_id } });
                }
                return false;
            }
        },
    },
    mounted() {
        const e = this.$refs;
        var self = this;
        this.trackTableLoading(e.tablesuswa);
        this.table = createTable(e.tablesuswa, {
            "title": "Rapor Psikotes",
            "roles": ["read"],
            "ajax": "/siswa/ujian/hasil_ujian",
            "columns": [
                { "data": "jenis_psikotes" },
                { "data": "ujian_title" },
                { "data": "tanggal",
                render: function (data, type, row, meta) {
                    return data ? moment(data).format("DD/MM/YYYY hh:mm") : '-';
                } },
                { "data": "mapel_id" },
            ],
            filter: false,
            scrollX: true,
            order: [[2, 'desc']],
            paramData: function(d) {
                d.paket = 4;
                d.ujian_type = self.$route.params.jenis;
            },
            rowCallback: function (row, data) {
                $("td:eq(3)", row).html(
                    '<button class="btn btn-sm btn-info btn-detail" data-mapel="'+data.mapel_id+'" data-hasil="'+data.hasil_id+'" data-ujian="'+data.ujian_code+'"><i class="fas fa-chart-bar"></i> Lihat Detail</button>'
                );
            },
        });
    }
}
</script>
<style type="text/css" scoped>
    /* Chrome, Safari, Edge, Opera */
    input::-webkit-outer-spin-button,
    input::-webkit-inner-spin-button {
      -webkit-appearance: none;
      margin: 0;
    }

    /* Firefox */
    input[type=number] {
      -moz-appearance: textfield;
    }
    .table thead th {
        border-bottom:  none;
    }
    .table td, .table th {
        border-top:  none;   
    }
    .table td {
        vertical-align: middle;
    }
</style>
